import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { useSelector } from 'react-redux';
import MobileCampaignReport from './MobileCampaignReport';
import OverheadCampaignReport from './OverheadCampaignReport';
import Layout from '../../../layout/Layout';

const CampaignReportsAccordion = () => {
    const { initialLoginData } = useSelector((state) => state.user);
    const agreements = initialLoginData?.Agreements || [];

    // Only render a section the advertiser actually has data for, otherwise
    // an in-gym-only advertiser sees an empty Mobile accordion (and vice versa).
    const hasMobileReport = agreements.some((agreement) =>
        agreement.Contracts.some((contract) => contract.MobileUrl !== null)
    );

    const hasOverheadReport = agreements.some((agreement) =>
        agreement.Contracts.some(
            (contract) => contract.LocalMockupUrlNS || contract.LocalMockupUrlSS
        )
    );

    return (
        <Layout>
            <h5 className="report-heading">Select Reports to View</h5>
            <Accordion>
                {hasMobileReport && (
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>Mobile Campaign Reports</Accordion.Header>
                        <Accordion.Body>
                            <MobileCampaignReport />
                        </Accordion.Body>
                    </Accordion.Item>
                )}
                {hasOverheadReport && (
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>In-Gym Campaign Reports</Accordion.Header>
                        <Accordion.Body>
                            <OverheadCampaignReport />
                        </Accordion.Body>
                    </Accordion.Item>
                )}
            </Accordion>
        </Layout>
    );
};

export default CampaignReportsAccordion;
